import React, { useState, useEffect, useContext } from 'react';
import Header from '../../components/Header';
import MobileNavbar from '../../components/MobileNavbar';
import Sidebar from '../../components/Sidebar';
import './index.css';
import { Button, outlinedInputClasses } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import CarDropdown from '../../components/CarDropdown';
import CouponDropdown from '../../components/CouponDropdown';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Link, useNavigate } from 'react-router-dom';
import { useParams } from 'react-router';
import { get_user } from '../../API/user';
import { get_all_delivery_charges } from '../../API/setting';
import { get_coupons } from '../../API/coupon';
import { format, sub, add, isValid } from 'date-fns';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { setBooking, bookingSelector } from '../../reducers/bookingSlice';
import { AuthContext } from '../../contexts/AuthContext';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Carousel from 'react-material-ui-carousel';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import TimeDropdown from '../../components/TimeDropdown';
import { get_all_airlines } from '../../API/setting';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useCarsDropdown } from '../../hooks/useCarsDropdown';

export default function AddBooking(props) {
  // const [selectedFile, setSelectedFile] = useState();
  const { authAxios } = useContext(AuthContext);
  const [coupons, setCoupons] = useState([]);
  const [carDetail, setCarDetail] = useState(null);
  const [airports, setAirports] = useState([]);
  const [airlines, setAirlines] = useState([]);
  const { booking } = useSelector(bookingSelector);
  const [isFetching, setIsFetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const {
    fromDate,
    fromTime,
    untilDate,
    untilTime,
    pickupLocation,
    dropoffLocation,
    car: selectedCar,
    coupon_code: selectedCoupon,
    deliveryCharge,
    customer,
    customerName,
    flight_number,
    airline_name,
  } = booking;
  const { customer_id } = useParams();


  const format_date_time = (date, time) => {
    return date && format(date, 'yyyy-MM-dd') + 'T' + time;
  };

  const fromDateTime = isValid(fromDate)
    ? format_date_time(fromDate, fromTime)
    : null;
  const untilDateTime = isValid(untilDate)
    ? format_date_time(untilDate, untilTime)
    : null;

  const [carArray] = useCarsDropdown(fromDateTime, untilDateTime, customer_id);
  // console.log(location, deliveryCharge);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const getIntervalDays = (fromDate, fromTime, untilDate, untilTime) => {
    if (isValid(untilDate) && isValid(fromDate)) {
      return Math.ceil(
        (new Date(format_date_time(untilDate, untilTime)).getTime() -
          new Date(format_date_time(fromDate, fromTime)).getTime()) /
          (1000 * 60 * 60 * 24)
      );
    }
    return 0;
  };
  const days = getIntervalDays(fromDate, fromTime, untilDate, untilTime);
  const handleConfirm = () => {
    const coupon = coupons.find((coupon) => coupon.code == selectedCoupon);

    dispatch(
      setBooking({
        ...booking,
        customer: customer_id,
        insurance_expiry_date: customer?.insurance_expiry_date,
        start_date: format(fromDate, 'yyyy-MM-dd') + ' ' + fromTime,
        end_date: format(untilDate, 'yyyy-MM-dd') + ' ' + untilTime,
        daily_price: carDetail?.daily_price,
        img: carDetail.car_images[0]?.image,
        carName: carDetail.title,
        price: Number(carDetail?.daily_price) * days,
        days: days,
        isByPassed: true,
        isYoung: isYoung,
        coupon_amount:
          (coupon?.amount_type != 'A'
            ? coupon?.amount === 100 ? Math.ceil((days * carDetail?.daily_price * Math.abs(coupon?.amount)) / 100) : (days * carDetail?.daily_price * Math.abs(coupon?.amount)) / 100
            : Math.abs(coupon?.amount)) || 0,
        age: customer?.birth_date
          ? 30
          : (new Date(format_date_time(fromDate, fromTime)).getTime() -
              new Date(customer?.birth_date).getTime()) /
            31557600000,
      })
    );
    navigate('/payment');
  };

  // console.log(days);
  const handleSave = async (e) => {
    e.preventDefault();
    // const days =
    //   moment(untilDate).diff(moment(fromDate), 'days') +
    //   (untilTime > fromTime ? 1 : 0);

    //     booking.send_confirmation === 0 && setBook({
    //       ...booking,
    //       send_confirmation: false
    //     })

    if (
      new Date(customer?.insurance_expiry_date).getTime() <
      new Date(format_date_time(untilDate, untilTime)).getTime()
    ) {
      return confirmAlert({
        overlayClassName: 'errorModal',
        customUI: ({ onClose }) => {
          return (
            <div
              className='confModal'
              style={{
                height: '220px',
                marginTop: '50%',
                position: 'relative',
                paddingTop: '55px',
              }}
            >
              <div
                className='close_icon'
                style={{ top: '.55rem', right: '.25rem' }}
                onClick={() => onClose()}
              >
                <svg
                  width='25'
                  height='25'
                  viewBox='0 0 110 110'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M37.5625 37.5625L72.4375 72.4375M72.4375 37.5625L37.5625 72.4375L72.4375 37.5625Z'
                    stroke='#FF2552'
                    strokeWidth='11.625'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <path
                    d='M55 103.438C81.7513 103.438 103.438 81.7513 103.438 55C103.438 28.2487 81.7513 6.5625 55 6.5625C28.2487 6.5625 6.5625 28.2487 6.5625 55C6.5625 81.7513 28.2487 103.438 55 103.438Z'
                    stroke='#FF2552'
                    strokeWidth='11.625'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
              </div>
              <p style={{ color: 'red' }}>
                {
                  'This clients insurance is expired, or will expire before this trip is over.'
                }
              </p>
              <div className='btns'>
                <button
                  onClick={() => {
                    onClose();
                    navigate('/user_detail/' + customer?.id);
                  }}
                  className='secondary'
                  style={{ width: '120px', paddingTop: '10px' }}
                >
                  Update Now
                </button>
                {
                  <button
                    className='primary'
                    onClick={() => {
                      onClose();
                      handleSaveAfterCheckInsurance();
                    }}
                    style={{ width: '120px', paddingTop: '10px' }}
                  >
                    Update Later
                  </button>
                }
              </div>
            </div>
          );
        },
      });
    }

    if (!pickupLocation?.airport || !dropoffLocation?.airport) {
      return confirmAlert({
        overlayClassName: 'errorModal',
        customUI: ({ onClose }) => {
          return (
            <div
              className='confModal'
              style={{
                height: '190px',
                marginTop: '50%',
                position: 'relative',
              }}
            >
              <div
                className='close_icon'
                style={{ top: '.75rem', right: '.25rem' }}
                onClick={() => onClose()}
              >
                <svg
                  width='25'
                  height='25'
                  viewBox='0 0 110 110'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M37.5625 37.5625L72.4375 72.4375M72.4375 37.5625L37.5625 72.4375L72.4375 37.5625Z'
                    stroke='#FF2552'
                    strokeWidth='11.625'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <path
                    d='M55 103.438C81.7513 103.438 103.438 81.7513 103.438 55C103.438 28.2487 81.7513 6.5625 55 6.5625C28.2487 6.5625 6.5625 28.2487 6.5625 55C6.5625 81.7513 28.2487 103.438 55 103.438Z'
                    stroke='#FF2552'
                    strokeWidth='11.625'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
              </div>
              <p style={{ color: 'red', paddingTop: '30px' }}>
                {'Please select your pick-up and drop-off location.'}
              </p>
              <div className='btns'>
                <button
                  onClick={() => {
                    onClose();
                  }}
                  className='secondary'
                  style={{ width: '120px' }}
                >
                  Okay
                </button>
              </div>
            </div>
          );
        },
      });
    }

    handleSaveAfterCheckInsurance();
  };

  const handleSaveAfterCheckInsurance = async () => {
    console.log('🚀OUTPUT --> carDetail:', carDetail);
    if (!carDetail?.daily_price) {
      ErrorModal('Please select a car', 'error');
      return;
    }
    if (!(Number(carDetail.daily_price) * days > 0)) {
      ErrorModal('Invalid Price', 'error');
      return;
    }

    if (!customer_id) {
      ErrorModal('Customer Required.', 'error');
      return;
    }

    handleConfirm();
  };

  const ErrorModal = (message, status) => {
    return confirmAlert({
      overlayClassName: 'errorModal',
      customUI: ({ onClose }) => {
        return (
          <div
            className='confModal'
            style={{
              height: String(120 + message.length / 2) + 'px',
              marginTop: '50%',
              position: 'relative',
            }}
          >
            <div
              className='close_icon'
              style={{ top: '.75rem', right: '.25rem' }}
              onClick={() => onClose()}
            >
              <svg
                width='25'
                height='25'
                viewBox='0 0 110 110'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M37.5625 37.5625L72.4375 72.4375M72.4375 37.5625L37.5625 72.4375L72.4375 37.5625Z'
                  stroke='#FF2552'
                  strokeWidth='11.625'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  d='M55 103.438C81.7513 103.438 103.438 81.7513 103.438 55C103.438 28.2487 81.7513 6.5625 55 6.5625C28.2487 6.5625 6.5625 28.2487 6.5625 55C6.5625 81.7513 28.2487 103.438 55 103.438Z'
                  stroke='#FF2552'
                  strokeWidth='11.625'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
            </div>
            <h4>Are You Sure?</h4>
            <p style={{ color: 'red' }}>{message}</p>
            <div className='btns'>
              <button onClick={() => onClose()} className='secondary'>
                Cancel
              </button>
              {status != 'error' && (
                <button
                  className='primary'
                  onClick={() => {
                    onClose();
                    handleConfirm();
                  }}
                >
                  Bypass
                </button>
              )}
            </div>
          </div>
        );
      },
    });
  };

  useEffect(() => {
    const getCarCustomer = async () => {
      // let res = await get_all_cars(authAxios, format_date_time(fromDate, fromTime), format_date_time(untilDate, untilTime));
      // if (res.status === 200) {
      //   // should consider available cars.
      //   setCars(res.data);
      // } else {
      //   toast.error(Object.values(res.response.data)[0]);
      // }

      if (customer_id) {
        setIsFetching(true);
        let res = await get_user(authAxios, customer_id);
        if (res.status === 200) {
          setIsFetching(false);
          dispatch(
            setBooking({
              ...booking,
              customerName: res.data.name,
              customer: res.data,
              email: res.data.user.email,
              username: res.data.user.username,
              address: res.data.address || '_',
              postal_code: res.data.postal_code || '_',
              phone: res.data.phone || '_',
            })
          );
        } else {
          toast.error(Object.values(res.response.data)[0]);
        }
      }
    };

    getCarCustomer();
  }, [customer_id]);

  useEffect(() => {
    if (selectedCar) {
      setCarDetail(carArray?.data?.find((item) => item.id === selectedCar));
    }
  }, [carArray, booking.customer]);

  useEffect(() => {
    const getAllDeliveryCharges = async () => {
      let res = await get_all_delivery_charges(authAxios);
      if (res.status === 200) {
        setAirports(res.data);
      } else {
        toast.error(Object.values(res.response.data)[0]);
      }
    };

    const getCoupons = async () => {
      let res = await get_coupons(authAxios);
      if (res.status === 200) {
        setCoupons(res.data);
      } else {
        toast.error(Object.values(res.response.data)[0]);
      }
    };
    getAllDeliveryCharges();
    getCoupons();
  }, []);

  useEffect(() => {
    const updateDeliveryCharge = () => {
      let extraDays = 0;
      if (Number(untilTime.slice(0, 2)) < Number(fromTime.slice(0, 2))) {
        extraDays = 1;
      }

      console.log(pickupLocation?.delivery_charge, dropoffLocation?.delivery_charge, 'delivery charge calculation')
      console.log(pickupLocation, dropoffLocation, 'delivery charge calculation');
      if (days < 7) {
        dispatch(
          setBooking({
            ...booking,
            deliveryCharge: (
              Number(pickupLocation?.delivery_charge || 0) +
              Number(dropoffLocation?.delivery_charge || 0)
            ).toFixed(2),
          })
        );
      } else {
        dispatch(
          setBooking({
            ...booking,
            deliveryCharge: 0,
          })
        );
      }
    };
    updateDeliveryCharge();
  }, [
    pickupLocation,
    dropoffLocation,
    fromDate,
    fromTime,
    untilDate,
    untilTime,
  ]);

  useEffect(() => {
    const getAirlines = async () => {
      let res = await get_all_airlines(authAxios);
      if (res.status === 200) {
        setAirlines(res.data);
      } else {
        toast.error(Object.values(res.response.data)[0]);
      }
    };
    getAirlines();
  }, []);

  useEffect(() => {
    if (fromDate > untilDate) {
      const newDate = add(fromDate, { days: 3 });
      dispatch(setBooking({ ...booking, untilDate: newDate }));
    }
  }, [fromDate]);

  const CustomerModal = (customer) => {
    return confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='editModal overviewBooknigModal tripDetailModal'>
            <div
              className='close_icon'
              style={{ top: '1.5rem', right: '1.5rem' }}
              onClick={() => onClose()}
            >
              <svg
                width='25'
                height='25'
                viewBox='0 0 110 110'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M37.5625 37.5625L72.4375 72.4375M72.4375 37.5625L37.5625 72.4375L72.4375 37.5625Z'
                  stroke='#FF2552'
                  strokeWidth='11.625'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  d='M55 103.438C81.7513 103.438 103.438 81.7513 103.438 55C103.438 28.2487 81.7513 6.5625 55 6.5625C28.2487 6.5625 6.5625 28.2487 6.5625 55C6.5625 81.7513 28.2487 103.438 55 103.438Z'
                  stroke='#FF2552'
                  strokeWidth='11.625'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
            </div>
            {customer.license_image && (
              <Carousel className='trip_modal_carousal'>
                <img
                  key={customer.id}
                  src={customer.license_image}
                  alt='img'
                  width={'100%'}
                />
              </Carousel>
            )}
            <div className='body_header'>
              {/* <div> Trip Management </div> */}
            </div>
            <div className='tripDetail'>
              <div className='tripDetail_col'>
                <div>
                  Customer : <span>{customer.name}</span>
                </div>
                <div>
                  Email: <span>{customer.user.email}</span>
                </div>
                <div>
                  Insurance Policy No: <span>{customer.insurance_policy}</span>
                </div>
                {!customer.license_image && (
                  <div>
                    License: <span>Not Given</span>
                  </div>
                )}
                <div>
                  Birth Date:{' '}
                  <span>
                    {customer?.birth_date ? customer?.birth_date : 'Not Given'}
                  </span>
                </div>
              </div>
              <div className='tripDetail_col'>
                <div>
                  Phone No: <span>{customer.phone}</span>
                </div>
                <div>
                  Address: <span>{customer.address}</span>
                </div>
                <div>
                  Insurance Expiry Date:{' '}
                  <span>{customer?.insurance_expiry_date}</span>
                </div>
              </div>
            </div>
          </div>
        );
      },
    });
  };

  const isYoung =
    new Date(format_date_time(fromDate, fromTime)).getTime() -
      new Date(customer?.birth_date).getTime() <
    31557600000 * 25;

  return (
    <div className='dashboard page'>
      <Sidebar page='add_booking' />
      <div className='hero_content'>
        <MobileNavbar />
        <Header />
        <div className='pagewrapper'>
          <div className='addManualCar'>
            <h5>Add Booking</h5>
            <form
              action='#'
              onSubmit={(e) => handleSave(e)}
              className='card_details'
            >
              <div className='info_wrapper'>
                <div className='radio_wrapper'>
                  <div className='radio' style={{ position: 'relative' }}>
                    <input
                      hidden
                      type='radio'
                      name='person_type'
                      onChange={(e) => e.target.value}
                      id='previous_customer'
                    />
                    <label htmlFor='previous_customer' className='radio_label'>
                      <Button
                        required
                        className='user_upload_btn radio_btn'
                        variant='contained'
                        component={Link}
                        to='/all_users/add_booking'
                      >
                        <svg viewBox='0 0 76 76' fill='none'>
                          <circle cx='38' cy='38' r='38' fill='#1C2038' />
                          <path
                            d='M38.5004 20.625C39.2463 20.625 39.9616 20.9213 40.4891 21.4488C41.0165 21.9762 41.3129 22.6916 41.3129 23.4375C41.3129 24.1834 41.0165 24.8988 40.4891 25.4262C39.9616 25.9537 39.2463 26.25 38.5004 26.25C37.7544 26.25 37.0391 25.9537 36.5116 25.4262C35.9842 24.8988 35.6879 24.1834 35.6879 23.4375C35.6879 22.6916 35.9842 21.9762 36.5116 21.4488C37.0391 20.9213 37.7544 20.625 38.5004 20.625ZM38.5004 17.8125C37.0085 17.8125 35.5778 18.4051 34.5229 19.46C33.468 20.5149 32.8754 21.9457 32.8754 23.4375C32.8754 24.9293 33.468 26.3601 34.5229 27.415C35.5778 28.4699 37.0085 29.0625 38.5004 29.0625C39.9922 29.0625 41.4229 28.4699 42.4778 27.415C43.5327 26.3601 44.1254 24.9293 44.1254 23.4375C44.1254 21.9457 43.5327 20.5149 42.4778 19.46C41.4229 18.4051 39.9922 17.8125 38.5004 17.8125ZM41.9597 30.4406H35.041C33.7207 30.4406 32.4545 30.9651 31.5209 31.8987C30.5873 32.8323 30.0629 34.0985 30.0629 35.4188V42.8437C30.0321 43.6253 30.3097 44.3876 30.8359 44.9663C31.362 45.545 32.0944 45.8938 32.8754 45.9375V52.4906C32.8754 53.3857 33.2309 54.2442 33.8639 54.8771C34.4968 55.51 35.3552 55.8656 36.2504 55.8656H40.7504C41.2032 55.8659 41.6514 55.775 42.0684 55.5984C42.4854 55.4218 42.8626 55.1631 43.1775 54.8377C43.4924 54.5123 43.7386 54.1268 43.9015 53.7043C44.0643 53.2817 44.1404 52.8307 44.1254 52.3781V45.9375C44.9063 45.8938 45.6387 45.545 46.1648 44.9663C46.691 44.3876 46.9686 43.6253 46.9379 42.8437V35.4188C46.9379 34.0985 46.4134 32.8323 45.4798 31.8987C44.5462 30.9651 43.28 30.4406 41.9597 30.4406ZM32.8754 43.125V35.4188C32.8716 35.1333 32.925 34.85 33.0325 34.5855C33.14 34.3211 33.2994 34.0809 33.5012 33.879C33.7031 33.6771 33.9433 33.5178 34.2078 33.4103C34.4722 33.3028 34.7555 33.2493 35.041 33.2531H41.9597C42.2452 33.2493 42.5285 33.3028 42.7929 33.4103C43.0574 33.5178 43.2976 33.6771 43.4995 33.879C43.7013 34.0809 43.8607 34.3211 43.9682 34.5855C44.0757 34.85 44.1291 35.1333 44.1254 35.4188V43.125H41.3129V52.4344C41.3129 52.5836 41.2536 52.7266 41.1481 52.8321C41.0426 52.9376 40.8995 52.9969 40.7504 52.9969H36.2504C36.1012 52.9969 35.9581 52.9376 35.8526 52.8321C35.7471 52.7266 35.6879 52.5836 35.6879 52.4344V43.125H32.8754Z'
                            fill='#4FC8E9'
                          />
                        </svg>
                        {customerName ? customerName : 'Select Existing Client'}
                      </Button>
                    </label>
                    {customer && (
                      <div
                        onClick={() => CustomerModal(customer)}
                        style={{
                          position: 'absolute',
                          bottom: '10px',
                          right: '20px',
                          fontSize: '12px',
                          background: '#4fc8e9',
                          borderRadius: '5px',
                          padding: '4px 8px',
                          cursor: 'pointer',
                        }}
                      >
                        View
                      </div>
                    )}
                  </div>
                  <div className='radio'>
                    <input
                      hidden
                      type='radio'
                      name='person_type'
                      onChange={(e) => e.target.value}
                      id='add_new_person'
                    />
                    <label htmlFor='add_new_person' className='radio_label'>
                      <Button
                        required
                        className='user_upload_btn radio_btn'
                        variant='contained'
                        component={Link}
                        to='/add_person'
                      >
                        <svg viewBox='0 0 76 76' fill='none'>
                          <circle cx='38' cy='38' r='38' fill='#1C2038' />
                          <path
                            fillRule='evenodd'
                            clipRule='evenodd'
                            d='M46.5023 43.3671H43.6898V48.9921H38.0648V51.8046H43.6898V57.4296H46.5023V51.8046H52.1273V48.9921H46.5023V43.3671ZM34.0036 21.3424C33.6964 21.137 33.3519 20.9942 32.9896 20.922C32.6273 20.8498 32.2543 20.8497 31.8919 20.9216C31.5295 20.9936 31.1849 21.1362 30.8776 21.3413C30.5704 21.5465 30.3066 21.8101 30.1012 22.1172C29.8959 22.4243 29.753 22.7689 29.6808 23.1312C29.6086 23.4935 29.6085 23.8665 29.6804 24.2289C29.7524 24.5912 29.895 24.9359 30.1001 25.2431C30.3053 25.5504 30.5689 25.8142 30.8761 26.0196C31.4963 26.4343 32.2559 26.5857 32.9877 26.4404C33.7195 26.295 34.3637 25.865 34.7784 25.2447C35.1931 24.6245 35.3445 23.8649 35.1992 23.1331C35.0539 22.4012 34.6238 21.7571 34.0036 21.3424ZM29.3151 19.0024C29.929 18.5768 30.6214 18.2777 31.3521 18.1226C32.0828 17.9675 32.837 17.9595 33.5708 18.099C34.3046 18.2385 35.0033 18.5228 35.6261 18.9353C36.2488 19.3477 36.7832 19.8801 37.198 20.5012C37.6128 21.1224 37.8998 21.82 38.0421 22.5533C38.1844 23.2866 38.1792 24.0408 38.0269 24.7721C37.8746 25.5034 37.5781 26.1969 37.1549 26.8124C36.7316 27.4279 36.19 27.9529 35.5617 28.3568C34.3211 29.1422 32.8225 29.4114 31.3861 29.1069C29.9497 28.8024 28.6894 27.9482 27.8742 26.727C27.059 25.5057 26.7537 24.0141 27.0235 22.5708C27.2933 21.1274 28.1167 19.8468 29.3179 19.0024H29.3151ZM28.9804 30.6827H35.8992C37.2195 30.6827 38.4857 31.2072 39.4192 32.1408C40.3528 33.0743 40.8773 34.3405 40.8773 35.6608V37.7421H38.0648V35.6608C38.0686 35.3754 38.0152 35.0921 37.9077 34.8276C37.8002 34.5632 37.6408 34.3229 37.4389 34.1211C37.2371 33.9192 36.9968 33.7598 36.7324 33.6523C36.4679 33.5448 36.1846 33.4914 35.8992 33.4952H28.9804C28.695 33.4914 28.4117 33.5448 28.1472 33.6523C27.8828 33.7598 27.6425 33.9192 27.4407 34.1211C27.2388 34.3229 27.0794 34.5632 26.972 34.8276C26.8645 35.0921 26.811 35.3754 26.8148 35.6608V43.3671H29.6273V52.6764C29.6273 52.8256 29.6866 52.9687 29.7921 53.0742C29.8975 53.1797 30.0406 53.2389 30.1898 53.2389H32.4398V56.1077H30.1898C29.2947 56.1077 28.4363 55.7521 27.8033 55.1192C27.1704 54.4862 26.8148 53.6278 26.8148 52.7327V46.1796C26.0339 46.1359 25.3014 45.7871 24.7753 45.2084C24.2492 44.6297 23.9716 43.8673 24.0023 43.0858V35.6608C24.0023 34.3405 24.5268 33.0743 25.4604 32.1408C26.3939 31.2072 27.6601 30.6827 28.9804 30.6827Z'
                            fill='#4FC8E9'
                          />
                        </svg>
                        Add New Client
                      </Button>
                    </label>
                  </div>
                </div>
                <div className='info_row info_row_date '>
                  <div className='field'>
                    <div>From</div>
                    <div className='date_time'>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // shouldDisableDate={(23, 24, 25) => true}
                          disablePast
                          label='Date'
                          // readOnly
                          value={fromDate}
                          onChange={(newValue) => {
                            if (
                              JSON.stringify(newValue) &&
                              JSON.stringify(newValue) !== 'null'
                            ) {
                              if (untilDate && newValue > new Date(untilDate)) {
                                const newUntilDate = add(newValue, { days: 3 });
                                // console.log('🚀OUTPUT --> newUntilDate:',newUntilDate);
                                dispatch(
                                  setBooking({
                                    ...booking,
                                    fromDate: newValue,
                                    untilDate: newUntilDate,
                                  })
                                );
                                // toast.error('From date should be less then Until Date');
                              } else {
                                dispatch(
                                  setBooking({ ...booking, fromDate: newValue })
                                );
                              }
                            }
                          }}
                          slotProps={{
                            textField: { 
                              sx: {
                                [`& .${outlinedInputClasses.notchedOutline}`]: {
                                  border: '1px solid #8d94be !important',
                                }
                              }
                             },
                          }}
                        />
                      </LocalizationProvider>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <TimeDropdown
                          setSelectedTime={(value) =>
                            dispatch(
                              setBooking({ ...booking, fromTime: value })
                            )
                          }
                          selectedTime={fromTime}
                        />
                      </LocalizationProvider>
                    </div>
                  </div>
                  <div className='field'>
                    <div>Until</div>
                    <div className='date_time'>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          disablePast
                          label='Date'
                          // format={'yyyy-mm-dd'}
                          value={untilDate}
                          onChange={(newValue) => {
                            if (
                              JSON.stringify(newValue) &&
                              JSON.stringify(newValue) !== 'null'
                            ) {
                              if (fromDate && newValue < new Date(fromDate)) {
                                toast.error(
                                  'Until date should be greater then From  Ddte'
                                );
                              } else {
                                dispatch(
                                  setBooking({
                                    ...booking,
                                    untilDate: newValue,
                                  })
                                );
                              }
                            }
                          }}
                          slotProps={{
                            textField: { 
                              sx: {
                                [`& .${outlinedInputClasses.notchedOutline}`]: {
                                  border: '1px solid #8d94be !important',
                                }
                              }
                             },
                          }}
                          shouldDisableDate={(dateParam) => {
                            //your_condition here
                            //return true to disabled and false to enable
                            // console.log(fromDate);
                            if (!isValid(fromDate)) return true;

                            const fromFormatted = sub(fromDate, { days: 0 })
                              ?.toISOString()
                              .split('T')[0];
                            const currentDate = dateParam
                              .toISOString()
                              .split('T')[0];
                            // console.log(fromFormatted);

                            return fromFormatted > currentDate ? true : false;
                          }}
                        />
                      </LocalizationProvider>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <TimeDropdown
                          setSelectedTime={(value) =>
                            dispatch(
                              setBooking({ ...booking, untilTime: value })
                            )
                          }
                          selectedTime={untilTime}
                        />
                      </LocalizationProvider>
                    </div>
                  </div>
                </div>
                <CarDropdown
                  // carData={cars}
                  setSelectedCar={(value) => {
                    // console.log('🚀OUTPUT --> value:', value);
                    dispatch(setBooking({ ...booking, car: value }));
                  }}
                  setSelectedCarDetail={(value) => setCarDetail(value)}
                  selectedCar={selectedCar}
                  fromDate={
                    isValid(fromDate)
                      ? format_date_time(fromDate, fromTime)
                      : null
                  }
                  setCarsDDLoading={(loading)=> {
                    setIsLoading(loading);
                  }}
                  untilDate={
                    isValid(untilDate)
                      ? format_date_time(untilDate, untilTime)
                      : null
                  }
                  bookingPeriod={days}
                  deliveryCharge={deliveryCharge}
                  coupon={coupons.find(
                    (coupon) => coupon.code == selectedCoupon
                  )}
                  isYoung={isYoung}
                />

                <CouponDropdown
                  couponData={coupons}
                  setSelectedCoupon={(value) =>
                    dispatch(setBooking({ ...booking, coupon_code: value }))
                  }
                  selectedCoupon={selectedCoupon}
                />
                <div className='info_row'>
                  <div className='field'>
                    Pickup Location
                    <FormControl
                      className='edit_dropdown'
                      sx={{ m: 1, minWidth: 120 }}
                    >
                      {/* <InputLabel id='airport_name'>
                        Select Airport Name
                      </InputLabel> */}
                      <Select
                        className='airport_name'
                        labelId='airport_name'
                        id='demo-simple-select'
                        value={pickupLocation?.airport}
                        label='Enter Airport Name'
                      >
                        {airports.map((airport) => (
                          <MenuItem
                            key={airport.id}
                            className='airport_name_menu_item'
                            value={airport.airport}
                            onClick={() => {
                              dispatch(
                                setBooking({
                                  ...booking,
                                  pickupLocation: airport,
                                  // dropoffLocation:
                                  //   booking?.dropoffLocation ?? airport,
                                })
                              );
                            }}
                          >
                            <svg
                              style={{ marginRight: '10px' }}
                              width='14'
                              viewBox='0 0 14 17'
                              fill='none'
                            >
                              <path
                                d='M7 16.796L2.227 12.023C1.28301 11.079 0.64014 9.87626 0.379696 8.56689C0.119253 7.25752 0.25293 5.90032 0.763824 4.66693C1.27472 3.43353 2.13988 2.37933 3.24991 1.63764C4.35994 0.895939 5.66498 0.500061 7 0.500061C8.33502 0.500061 9.64006 0.895939 10.7501 1.63764C11.8601 2.37933 12.7253 3.43353 13.2362 4.66693C13.7471 5.90032 13.8808 7.25752 13.6203 8.56689C13.3599 9.87626 12.717 11.079 11.773 12.023L7 16.796ZM10.7125 10.9625C11.4467 10.2283 11.9466 9.29279 12.1492 8.27441C12.3517 7.25602 12.2477 6.20045 11.8503 5.24117C11.4529 4.28189 10.78 3.46198 9.91669 2.88513C9.05334 2.30827 8.03833 2.00038 7 2.00038C5.96167 2.00038 4.94666 2.30827 4.08331 2.88513C3.21997 3.46198 2.54706 4.28189 2.14969 5.24117C1.75231 6.20045 1.64831 7.25602 1.85084 8.27441C2.05337 9.29279 2.55333 10.2283 3.2875 10.9625L7 14.675L10.7125 10.9625ZM7 8.75C6.60218 8.75 6.22065 8.59197 5.93934 8.31066C5.65804 8.02936 5.5 7.64783 5.5 7.25C5.5 6.85218 5.65804 6.47065 5.93934 6.18934C6.22065 5.90804 6.60218 5.75 7 5.75C7.39783 5.75 7.77936 5.90804 8.06066 6.18934C8.34197 6.47065 8.5 6.85218 8.5 7.25C8.5 7.64783 8.34197 8.02936 8.06066 8.31066C7.77936 8.59197 7.39783 8.75 7 8.75Z'
                                fill='white'
                              />
                            </svg>
                            {airport.airport} (+${airport.delivery_charge})
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div className='field'>
                    Dropoff Location
                    <FormControl
                      className='edit_dropdown'
                      sx={{ m: 1, minWidth: 120 }}
                    >
                      <Select
                        className='airport_name'
                        labelId='airport_name'
                        id='demo-simple-select'
                        value={dropoffLocation?.airport}
                        label='Enter Airport Name'
                      >
                        {airports.map((airport) => (
                          <MenuItem
                            key={airport.id}
                            className='airport_name_menu_item'
                            value={airport.airport}
                            onClick={() => {
                              dispatch(
                                setBooking({
                                  ...booking,
                                  // pickupLocation:
                                  //   booking?.pickupLocation ?? airport,
                                  dropoffLocation: airport,
                                })
                              );
                            }}
                          >
                            <svg
                              style={{ marginRight: '10px' }}
                              width='14'
                              viewBox='0 0 14 17'
                              fill='none'
                            >
                              <path
                                d='M7 16.796L2.227 12.023C1.28301 11.079 0.64014 9.87626 0.379696 8.56689C0.119253 7.25752 0.25293 5.90032 0.763824 4.66693C1.27472 3.43353 2.13988 2.37933 3.24991 1.63764C4.35994 0.895939 5.66498 0.500061 7 0.500061C8.33502 0.500061 9.64006 0.895939 10.7501 1.63764C11.8601 2.37933 12.7253 3.43353 13.2362 4.66693C13.7471 5.90032 13.8808 7.25752 13.6203 8.56689C13.3599 9.87626 12.717 11.079 11.773 12.023L7 16.796ZM10.7125 10.9625C11.4467 10.2283 11.9466 9.29279 12.1492 8.27441C12.3517 7.25602 12.2477 6.20045 11.8503 5.24117C11.4529 4.28189 10.78 3.46198 9.91669 2.88513C9.05334 2.30827 8.03833 2.00038 7 2.00038C5.96167 2.00038 4.94666 2.30827 4.08331 2.88513C3.21997 3.46198 2.54706 4.28189 2.14969 5.24117C1.75231 6.20045 1.64831 7.25602 1.85084 8.27441C2.05337 9.29279 2.55333 10.2283 3.2875 10.9625L7 14.675L10.7125 10.9625ZM7 8.75C6.60218 8.75 6.22065 8.59197 5.93934 8.31066C5.65804 8.02936 5.5 7.64783 5.5 7.25C5.5 6.85218 5.65804 6.47065 5.93934 6.18934C6.22065 5.90804 6.60218 5.75 7 5.75C7.39783 5.75 7.77936 5.90804 8.06066 6.18934C8.34197 6.47065 8.5 6.85218 8.5 7.25C8.5 7.64783 8.34197 8.02936 8.06066 8.31066C7.77936 8.59197 7.39783 8.75 7 8.75Z'
                                fill='white'
                              />
                            </svg>
                            {airport.airport} (+${airport.delivery_charge})
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                </div>
                <div className='info_row'>
                  <div className='field'>
                    Airline
                    <FormControl
                      className='edit_dropdown'
                      sx={{ m: 1, minWidth: 120 }}
                    >
                      {/* <InputLabel id='airport_name'>
                        Select Airport Name
                      </InputLabel> */}
                      <Select
                        className='airport_name'
                        labelId='airport_name'
                        id='demo-simple-select'
                        value={airline_name}
                        label='Enter Airport Name'
                        onChange={(e) =>
                          dispatch(
                            setBooking({
                              ...booking,
                              airline_name: e.target.value,
                            })
                          )
                        }
                      >
                        {airlines.map((airline) => (
                          <MenuItem
                            key={airline.id}
                            className='airport_name_menu_item'
                            value={airline.name}
                          >
                            <svg
                              style={{ marginRight: '10px' }}
                              width='14'
                              viewBox='0 0 14 17'
                              fill='none'
                            >
                              <path
                                d='M7 16.796L2.227 12.023C1.28301 11.079 0.64014 9.87626 0.379696 8.56689C0.119253 7.25752 0.25293 5.90032 0.763824 4.66693C1.27472 3.43353 2.13988 2.37933 3.24991 1.63764C4.35994 0.895939 5.66498 0.500061 7 0.500061C8.33502 0.500061 9.64006 0.895939 10.7501 1.63764C11.8601 2.37933 12.7253 3.43353 13.2362 4.66693C13.7471 5.90032 13.8808 7.25752 13.6203 8.56689C13.3599 9.87626 12.717 11.079 11.773 12.023L7 16.796ZM10.7125 10.9625C11.4467 10.2283 11.9466 9.29279 12.1492 8.27441C12.3517 7.25602 12.2477 6.20045 11.8503 5.24117C11.4529 4.28189 10.78 3.46198 9.91669 2.88513C9.05334 2.30827 8.03833 2.00038 7 2.00038C5.96167 2.00038 4.94666 2.30827 4.08331 2.88513C3.21997 3.46198 2.54706 4.28189 2.14969 5.24117C1.75231 6.20045 1.64831 7.25602 1.85084 8.27441C2.05337 9.29279 2.55333 10.2283 3.2875 10.9625L7 14.675L10.7125 10.9625ZM7 8.75C6.60218 8.75 6.22065 8.59197 5.93934 8.31066C5.65804 8.02936 5.5 7.64783 5.5 7.25C5.5 6.85218 5.65804 6.47065 5.93934 6.18934C6.22065 5.90804 6.60218 5.75 7 5.75C7.39783 5.75 7.77936 5.90804 8.06066 6.18934C8.34197 6.47065 8.5 6.85218 8.5 7.25C8.5 7.64783 8.34197 8.02936 8.06066 8.31066C7.77936 8.59197 7.39783 8.75 7 8.75Z'
                                fill='white'
                              />
                            </svg>
                            {airline.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div className='field'>
                    Flight No
                    <FormControl
                      className='edit_dropdown'
                      sx={{ m: 1, minWidth: 120 }}
                    >
                      <TextField
                        size='small'
                        placeholder='Flight No'
                        value={flight_number}
                        onChange={(e) =>
                          dispatch(
                            setBooking({
                              ...booking,
                              flight_number: e.target.value,
                            })
                          )
                        }
                      />
                    </FormControl>
                  </div>
                </div>
                <div className='info_row'>
                  <FormControlLabel
                    className='booking feature_checkbox_wrapper'
                    control={
                      <Checkbox
                        className='feature_checkbox'
                        checked={booking.send_confirmation}
                        onChange={(e) =>
                          dispatch(
                            setBooking({
                              ...booking,
                              send_confirmation: e.target.checked,
                            })
                          )
                        }
                      />
                    }
                    label={
                      <div className='feature_checkbox_label_wrapper'>
                        <div className='feature_checkbox_label'>
                          {/* {getPage(packagePage.page)?.mutate == true? "View": 'View/Mutate'} */}
                          Send Confirmation
                        </div>
                      </div>
                    }
                  />
                </div>
              </div>
              {
                // Calculate if client will be less than 25 years old at booking start
                new Date(format_date_time(fromDate, fromTime)).getTime() -
                  new Date(customer?.birth_date).getTime() <
                  // milliseconds in a year * 25 years
                  31557600000 * 25 && (
                  <p style={{ color: 'red' }}>
                    This client will be under 25 years of age at the time of the
                    booking. A Young Driver Fee will be applied to the booking
                    cost.
                  </p>
                )
              }
              <div className='confirmation_btn'>
                <button type='submit'> Save </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isFetching || isLoading}
      >
        <CircularProgress color='inherit' />
      </Backdrop>
    </div>
  );
}
